// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SDca","left":"styles_left__2SFL6","desktopActions":"styles_desktopActions__1sgUw","title":"styles_title__BN-fs"};